export function formatPhoneNumber(phone: string | null | undefined): string {
   if (!phone) return ""
   return phone.replace(/(\d{2})(?=\d)/g, "$1 ")
}
